import { render, staticRenderFns } from "./GroupRoleSelect.vue?vue&type=template&id=f9a69c8c&"
import script from "./GroupRoleSelect.vue?vue&type=script&lang=ts&"
export * from "./GroupRoleSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports